import styles from './missing.module.css'

export const Missing = ({ data, country }) => {
    return <div className={styles.missing}>MISSING DATA</div>;
};
